"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const react_router_dom_1 = require("react-router-dom");
const common_1 = require("@Const/common");
const UserMenu_1 = __importDefault(require("@Components/Navigations/UserMenu"));
const RightsHoldersTray_1 = __importDefault(require("@Components/Navigations/RightsHoldersTray"));
const contexts_1 = require("@App/contexts");
const mobx_react_1 = require("mobx-react");
const clsx_1 = __importDefault(require("clsx"));
const MemberSongwriterSwitcher_1 = __importDefault(require("@Components/Navigations/MemberSongwriterSwitcher"));
const NavBarWrapper_1 = __importDefault(require("@Components/Navigations/NavBar/NavBarWrapper"));
const MobileSubNavigation_1 = __importDefault(require("@Components/Navigations/NavBar/MobileSubNavigation"));
const PublicSearchNavLink_1 = __importDefault(require("@Components/Navigations/PublicSearchNavLink"));
const HelpMenu_1 = __importDefault(require("@Components/Navigations/HelpMenu"));
const react_inbox_1 = require("@trycourier/react-inbox");
const RequireFeatureFlag_1 = __importDefault(require("@Components/RequireFeatureFlag"));
const LoggedInNavBar = () => {
    const { userStore, rightsholderSearchStore, uiStore, popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const location = (0, react_router_dom_1.useLocation)();
    const burgerClick = () => {
        setIsOpen(!isOpen);
    };
    const onCloseMenu = () => {
        setIsOpen(false);
    };
    const closeTray = () => {
        popupStore.setRightsholderTrayState(false);
    };
    (0, react_1.useEffect)(() => {
        onCloseMenu();
        closeTray();
    }, [location]);
    const isInternal = userStore.isInternal;
    const rightsHolderCount = rightsholderSearchStore.rightsholderCount;
    const isMobile = uiStore.isMobile;
    const trayIsOpen = popupStore.rightsholderTrayState;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(NavBarWrapper_1.default, { wrapperClass: (0, clsx_1.default)(isInternal && 'internal-user'), accountingBlock: react_1.default.createElement(MemberSongwriterSwitcher_1.default, null), rightBlock: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", { className: 'right-links only-desktop' },
                    react_1.default.createElement(PublicSearchNavLink_1.default, null),
                    react_1.default.createElement(HelpMenu_1.default, null),
                    react_1.default.createElement(RequireFeatureFlag_1.default, { flagKey: 'courier-notifications' },
                        react_1.default.createElement(react_inbox_1.Inbox, null))),
                react_1.default.createElement(UserMenu_1.default, null)), burgerBlock: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: `burger-button`, onClick: burgerClick }, isOpen ? (react_1.default.createElement("img", { className: "close-icon", src: common_1.ICONS.close, alt: "close" })) : (react_1.default.createElement("img", { src: common_1.ICONS.menu, alt: "menu" })))) }, isMobile && react_1.default.createElement(MobileSubNavigation_1.default, { isOpen: isOpen })),
        !isMobile && rightsHolderCount > 1 && trayIsOpen && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(RightsHoldersTray_1.default, null),
            react_1.default.createElement("div", { className: "stub" })))));
};
exports.default = (0, mobx_react_1.observer)(LoggedInNavBar);
